





















import { Component, Vue } from "vue-property-decorator";
import ComplaintResponseList from "@/components/complaint-response/ComplaintResponseList.vue";
import ComplaintResponseDashboard from "@/components/complaint-response/ComplaintResponseDashboard.vue";
import ComplaintResponseMonthlyReport from "@/components/complaint-response/ComplaintResponseMonthlyReport.vue";

@Component({
  components: {
    ComplaintResponseList,
    ComplaintResponseDashboard,
    ComplaintResponseMonthlyReport,
  },
})
export default class ComplaintResponsePage extends Vue {
  tab = 0;
}
